import React from "react";
import {useCountDown} from "ahooks";

type TSignupInfoCountdown = {
  examExpiresTime: number;
}

const SignupInfoCountdown:React.FC<TSignupInfoCountdown> = ({examExpiresTime}) => {
  const [countdown, formattedRes] = useCountDown({
    targetDate: examExpiresTime,
  });
  const { days, hours, minutes, seconds } = formattedRes;
  return (
    <div>
      {countdown > 0 && (
        <div>距离考试结束还有{days}天{hours}小时{minutes}分{seconds}秒</div>
      )}
    </div>
  )
}
export default SignupInfoCountdown;
